export enum BulletEnum {
  dot,
  check,
  cross,
}
export interface IListPanelOption {
  label: string;
  bullet: BulletEnum;
}
